module.exports = __webpack_public_path__ + "img/flat-eprice-button-honda.37265b31.png";